import Vue from 'vue'

const state = {
    options: {
        useraction: null,
        checkedrows: [],
        selected: false,
        delete: false,
        isSideActive: [1, 0, 0],
        sidechangeflag: false,
        userflag: true
    }
}

const getters = {}

const mutations = {
    UpdateUserAction(state, payload) {
        Vue.set(state.options, "useraction", payload)
    },
    UpdateCheckedRows(state, payload) {
        Vue.set(state.options, "checkedrows", payload)
    },
    UpdateSelected(state, payload) {
        Vue.set(state.options, "selected", payload)
    },
    UpdateDelete(state, payload) {
        Vue.set(state.options, "delete", payload)
    },
    UpdateisSideActive(state, payload) {
        Vue.set(state.options, "isSideActive", payload)
    },
    UpdateSideCangeFlag(state, payload) {
        Vue.set(state.options, "sidechangeflag", payload)
    },
    UpdateUserFlag(state, payload) {
        Vue.set(state.options, "userflag", payload)
    }
}

const actions = {
    UpdateUserAction: ((ctx, uAction) => {
        ctx.commit('UpdateUserAction', uAction)
    }),
    UpdateCheckedRows: ((ctx, uAction) => {
        ctx.commit('UpdateCheckedRows', uAction)
    }),
    UpdateSelected: ((ctx, uAction) => {
        ctx.commit('UpdateSelected', uAction)
    }),
    UpdateDelete: ((ctx, uAction) => {
        ctx.commit('UpdateDelete', uAction)
    }),
    UpdateisSideActive: ((ctx, uAction) => {
        ctx.commit('UpdateisSideActive', uAction)
    }),
    UpdateSideCangeFlag: ((ctx, uAction) => {
        ctx.commit('UpdateSideCangeFlag', uAction)
    }),
    UpdateUserFlag: ((ctx, uAction) => {
        ctx.commit('UpdateUserFlag', uAction)
    })
}
export default {
    state,
    getters,
    actions,
    mutations
}